export default __webpack_public_path__ + "static/media/unranked.f951d1fc.png";